import { render, staticRenderFns } from "./TicketFormV2.vue?vue&type=template&id=1de648b5&scoped=true&"
import script from "./TicketFormV2.vue?vue&type=script&lang=js&"
export * from "./TicketFormV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de648b5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de648b5')) {
      api.createRecord('1de648b5', component.options)
    } else {
      api.reload('1de648b5', component.options)
    }
    module.hot.accept("./TicketFormV2.vue?vue&type=template&id=1de648b5&scoped=true&", function () {
      api.rerender('1de648b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/TicketFormV2.vue"
export default component.exports